module.exports = __webpack_public_path__ + "img/yuan.89f75a76.png";